import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { concat, from, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { FieldType } from '@ngx-formly/core';
import { AccountMembership, APIService, EntityList, ListCreationType, SearchableContactFilterInput, SearchableEntityListFilterInput, SearchableEntityListSortableFields, SearchableEntityListSortInput, SearchableSortDirection } from '../../../API.service.custom';
import { ToastrService } from 'ngx-toastr';
import { DataShareService } from '../../../../services/data-share.service';
import { NgSelectComponent, NgLoadingSpinnerTemplateDirective } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgClass, AsyncPipe } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';

@Component({
    selector: 'app-select-address-component',
    templateUrl: './select-address-component.component.html',
    styleUrls: ['./select-address-component.component.scss'],
    imports: [NgSelectComponent, FormsModule, NgxIntlTelInputModule, NgClass, ExtendedModule, NgLoadingSpinnerTemplateDirective, AsyncPipe]
})
export class SelectAddressComponentComponent extends FieldType implements OnInit {

  @Input() dropdownPosition = 'top';

  @Input() parentFilter = null;

  people$: Observable<EntityList[]>;
  peopleLoading = false;
  peopleInput$ = new Subject<string>();


  @Input() placeholder: string = "Select from options";
  @Input() addressComponent: string = "city";
  @Input() allowAdding: boolean = false;
  @Input() allowMultiple: boolean = false;
  @Input() preSelectedAddress: any = null;
  @Input() readonly: boolean = false;
  @Input() cssClass : string = "entity-selector";
  @Output() selectedAddressComponent = new EventEmitter();
  @Input() appendTo = undefined;

  activAccountSubscription;
  activeAccount: AccountMembership = null;

  selectedContact: any | any[] = null;

  searchTerm : string = null;


  constructor(private api: APIService, private toastr: ToastrService, private dataService: DataShareService,) {
    super();
  }

  ngOnInit() {
    this.loadPeople();
    if (this.field && this.props) {
      if (this.props.placeholder !== undefined && this.props.placeholder !== null  && this.props.placeholder !== "") {
        this.placeholder = this.props.placeholder;
      }
      
      if (this.props.multiple1 !== undefined && this.props.multiple1 !== null) {
        this.allowMultiple = this.props.multiple1;
      }
      
      if (this.props.allowAdding !== undefined && this.props.allowAdding !== null) {
        this.allowAdding = this.props.allowAdding;
      }
      
      if (this.props.readonly !== undefined && this.props.readonly !== null) {
        this.readonly = this.props.readonly;
      }
      if (this.props.preSelectedAddress !== undefined && this.props.preSelectedAddress !== null) {
        this.preSelectedAddress = this.props.preSelectedAddress;
      }
    } 
    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        this.activeAccount = param;
        console.log("+++++++++++++ The active account is :", this.activeAccount)
      }
      })
  }

  ngOnDestroy(): void {
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
      this.activAccountSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("preselected address is :", this.preSelectedAddress)
    if (this.preSelectedAddress && (!this.selectedContact || this.selectedContact.length == 0)) {
      console.log("setting contact preselection");
      if (this.allowMultiple){
        if(Array.isArray(this.preSelectedAddress))
          this.selectedContact = this.preSelectedAddress;
        else
          this.selectedContact = [this.preSelectedAddress];
      }
      else
        this.selectedContact = this.preSelectedAddress;
      this.selectedAddressComponent.emit(this.selectedContact);
    }
    else if ((!this.preSelectedAddress || this.preSelectedAddress?.length == 0) && ((this.allowMultiple && this.selectedContact?.length > 0) || (!this.allowMultiple && this.selectedContact))) {
      if (this.allowMultiple)
        this.selectedContact = [];
      else
        this.selectedContact = null;
      this.selectedAddressComponent.emit(this.selectedContact);
    }
  }

  // trackByFnPeople(item: EntityList) {
  //   return item.id
  // }

  private loadPeople() {
    this.people$ = concat(
      of([]), // default items
      this.peopleInput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => this.peopleLoading = true),
        tap(term => this.searchTerm = <any>term),
        switchMap(term => this.searchContact(term, `addresses.${this.addressComponent}`).pipe(
          catchError(() => of([])), // empty list on error
          tap(() => this.peopleLoading = false)
        ))
      )
    );
  }

  searchContact(term : string, field : string) : Observable<any[]>{
    let f = <SearchableContactFilterInput>{};
    if(this.parentFilter){
      f = JSON.parse(this.parentFilter)
    }
    else{
      f.accountId = { eq: this.activeAccount?.accountId }
      if (this.activeAccount.authorizationLevel == "MEMBER")
        f.ownerId = { eq: this.activeAccount.userId };
    }
    
    let searchFilter = <SearchableContactFilterInput>{}
    if (term && term != '') {
      let newTerm = '*' + term.toLowerCase() + '*';
      searchFilter[field] = { wildcard: newTerm };
      f = { and: [f, searchFilter] }
    }
    return from(this.api.AggregateSearchableQuery(this.activeAccount.accountId, "Contact", JSON.stringify(f), null, field, "count")).pipe(map(
      response => 
        {
          let parsedData = JSON.parse(response);
          return parsedData.aggregations[field].buckets;
        }
      ))
  }

  onTagSelectChange(event) {
    console.log("selection changed: added ", event);
    if (event) {
      this.selectedAddressComponent.emit(event);
      if (this.field && this.field.templateOptions) {
        if (Array.isArray(event)) {
          let keys = event.map(item => item.key);
          this.formControl.setValue(keys)
        }
        else{
          this.formControl.setValue(event.key)
        }
        // this.field.templateOptions.onContactSelectionChange(event);
        // console.log("the field : ", JSON.stringify(this.field))
      }
    }
  }

  onTagSelectRemove(event) {
    console.log("selection removed: removed ", event);
      this.selectedAddressComponent.emit(event);
      if (this.field && this.field.templateOptions) {
        this.formControl.setValue(null)
        // this.field.templateOptions.onContactSelectionChange(event);
        // console.log("the field : ", JSON.stringify(this.field))
      }
  }

}


